'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\t', '\n    margin-bottom: 10px;\n    padding: 10px;\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n    background-color: ', ';\n'], ['\n\t', '\n    margin-bottom: 10px;\n    padding: 10px;\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n    background-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    width: 100%;\n'], ['\n    width: 100%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    border: none;\n\tpadding: 0 10px;\n'], ['\n    border: none;\n\tpadding: 0 10px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    height: 50px;\n'], ['\n    height: 50px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _sizes = require('../../constants/sizes');

var _radius = require('../../constants/radius');

var _colors = require('../../constants/colors');

var _alignments = require('../../constants/alignments');

var _getElementValueByCode = require('../../helpers/getElementValueByCode');

var _getElementValueByCode2 = _interopRequireDefault(_getElementValueByCode);

var _getElementsByCode = require('../../helpers/getElementsByCode');

var _getElementsByCode2 = _interopRequireDefault(_getElementsByCode);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _addButton = require('../../atoms/buttons/addButton');

var _addButton2 = _interopRequireDefault(_addButton);

var _primaryButton = require('../../atoms/buttons/primaryButton');

var _primaryButton2 = _interopRequireDefault(_primaryButton);

var _secondaryButton = require('../../atoms/buttons/secondaryButton');

var _secondaryButton2 = _interopRequireDefault(_secondaryButton);

var _complete = require('../../atoms/icons/complete');

var _complete2 = _interopRequireDefault(_complete);

var _incomplete = require('../../atoms/icons/incomplete');

var _incomplete2 = _interopRequireDefault(_incomplete);

var _error = require('../../atoms/icons/error');

var _error2 = _interopRequireDefault(_error);

var _summaryIcons = require('../../atoms/icons/summaryIcons');

var _summaryIcons2 = _interopRequireDefault(_summaryIcons);

var _bullet = require('../lists/bullet');

var _bullet2 = _interopRequireDefault(_bullet);

var _informationModal = require('../../organisms/modals/informationModal');

var _informationModal2 = _interopRequireDefault(_informationModal);

var _confirmationModal = require('../../organisms/modals/confirmationModal');

var _confirmationModal2 = _interopRequireDefault(_confirmationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SummaryComponent = (0, _styledComponents2.default)(_container2.default)(_templateObject, function (_ref) {
    var isMobile = _ref.isMobile;
    return !isMobile && 'min-height: 250px;';
}, _colors.Colors.StrokeDark, _radius.Radius.large, _colors.Colors.LightMode);

var SummaryPrimaryButton = (0, _styledComponents2.default)(_primaryButton2.default)(_templateObject2);

var SummarySecondaryButton = (0, _styledComponents2.default)(_secondaryButton2.default)(_templateObject3);

var EmptySpacer = _styledComponents2.default.div(_templateObject4);

var Summary = function (_React$Component) {
    _inherits(Summary, _React$Component);

    function Summary() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, Summary);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Summary.__proto__ || Object.getPrototypeOf(Summary)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            deleteModal: false
        }, _this.getPrimaryButtonText = function (status) {
            var text = 'Summary.continue';
            if (status) {
                if (status === 'Error' || status === 'Complete') {
                    text = 'Summary.continue';
                } else {
                    text = 'Summary.start';
                }
            }

            return text;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Summary, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var header = (0, _getElementValueByCode2.default)(this.props.item && this.props.item.elements, 'Label') || this.props.label;
            var status = (0, _getElementValueByCode2.default)(this.props.item && this.props.item.elements, 'Status');
            var isEditButtonDisabled = (0, _getElementValueByCode2.default)(this.props.item && this.props.item.elements, 'EditButtonDisable') === 'true';
            var isDeleteButtonInvisible = (0, _getElementValueByCode2.default)(this.props.item && this.props.item.elements, 'DeleteButtonDisable') === 'true';
            var isDeleteButtonDisabled = this.props.item && this.props.item.unDeletable;

            var icon = this.props.icon || (0, _getElementValueByCode2.default)(this.props.elements, 'icon');
            var entity = this.props.item && this.props.item.value;
            var allowEdit = this.props.allowEdit;
            var allowDelete = this.props.allowDelete;
            var action = this.props.action;

            return _react2.default.createElement(
                _container2.default,
                { bottom: _sizes.Sizes.xs },
                _react2.default.createElement(
                    SummaryComponent,
                    {
                        top: _sizes.Sizes.xs,
                        bottom: _sizes.Sizes.xs,
                        horizontalAlignment: _alignments.Alignments.center,
                        verticalAlignment: _alignments.Alignments.center,
                        isMobile: this.context.screen.isMobile
                    },
                    icon && _react2.default.createElement(_summaryIcons2.default, { icon: icon, primary: _colors.Colors.Secondary }),
                    header && _react2.default.createElement(_header2.default, { size: _sizes.Sizes.sm, text: header, top: _sizes.Sizes.xxs, bottom: _sizes.Sizes.xxs }),
                    allowEdit === true && this.props.allowEdit === true && _react2.default.createElement(SummaryPrimaryButton, {
                        top: _sizes.Sizes.xxs, bottom: _sizes.Sizes.xxs,
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.getPrimaryButtonText(status) }),
                        clickEvent: function clickEvent() {
                            action ? _this2.props.editEvent(entity, action) : _this2.props.editEvent(entity);
                        },
                        disabled: isEditButtonDisabled
                    }),
                    allowDelete === true && this.props.allowDelete === true && !isDeleteButtonInvisible ? _react2.default.createElement(SummarySecondaryButton, {
                        inverse: true,
                        top: _sizes.Sizes.xxs,
                        bottom: _sizes.Sizes.xxs,
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Summary.delete' }),
                        clickEvent: function clickEvent() {
                            return _this2.setState({ deleteModal: true });
                        },
                        disabled: isDeleteButtonDisabled
                    }) : this.props.mode !== 'add' ? _react2.default.createElement(EmptySpacer, null) : null,
                    this.state.deleteModal && _react2.default.createElement(_confirmationModal2.default, {
                        animate: true,
                        size: _sizes.Sizes.md,
                        visible: this.state.deleteModal,
                        cancelEvent: function cancelEvent() {
                            return _this2.setState({ deleteModal: false });
                        },
                        closeEvent: function closeEvent() {
                            return _this2.setState({ deleteModal: false });
                        },
                        confirmEvent: function confirmEvent() {
                            action ? _this2.props.deleteEvent(entity, action) : _this2.props.deleteEvent(entity);
                            _this2.setState({ deleteModal: false });
                        }
                    }),
                    this.props.mode === 'add' && _react2.default.createElement(_addButton2.default, { clickEvent: this.props.addEvent })
                ),
                status === 'Error' && _react2.default.createElement(_informationModal2.default, {
                    toggle: _react2.default.createElement(
                        _container2.default,
                        { inline: true, verticalAlignment: _alignments.Alignments.center, horizontalAlignment: _alignments.Alignments.center },
                        _react2.default.createElement(_error2.default, null),
                        _react2.default.createElement(_label2.default, { left: _sizes.Sizes.xs, text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Summary.incomplete' }) })
                    ),
                    items: _react2.default.createElement(_bullet2.default, { references: (0, _getElementsByCode2.default)(this.props.item.elements, 'Messages') })
                }),
                status === 'Complete' && _react2.default.createElement(
                    _container2.default,
                    { inline: true, verticalAlignment: _alignments.Alignments.center, horizontalAlignment: _alignments.Alignments.center },
                    _react2.default.createElement(_complete2.default, null),
                    _react2.default.createElement(_label2.default, { left: _sizes.Sizes.xs, text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Summary.complete' }) })
                ),
                status === 'Incomplete' && _react2.default.createElement(_informationModal2.default, {
                    size: _sizes.Sizes.lg,
                    toggle: _react2.default.createElement(
                        _container2.default,
                        { inline: true, verticalAlignment: _alignments.Alignments.center, horizontalAlignment: _alignments.Alignments.center },
                        _react2.default.createElement(_incomplete2.default, null),
                        _react2.default.createElement(_label2.default, { left: _sizes.Sizes.xs, text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Summary.incomplete' }) })
                    ),
                    items: _react2.default.createElement(_bullet2.default, { references: (0, _getElementsByCode2.default)(this.props.item.elements, 'Messages') })
                })
            );
        }
    }]);

    return Summary;
}(_react2.default.Component);

Summary.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = Summary;